module.exports = __webpack_public_path__ + "static/media/awaitMark.b987df62.png";